export const SET_REFERRER = 'SET_REFERRER'

export const setReferrer = (referrer: string) => (dispatch: any) => {
  dispatch({
    type: SET_REFERRER,
    referrer,
  })
}
